import { api } from "@/lib/api/axios"
import { ResponseLogin } from "@/types/auth"

const AUTH_API_PATH = '/auth'

export const authService = {
  login: async (payload: { login: string, password: string }) => {
    return api.post<ResponseLogin>(`${AUTH_API_PATH}/login`, payload)
  },
  forgotPassword: async (payload: { login: string }) => {
    return api.post(`${AUTH_API_PATH}/forgot-password`, payload)
  },
  logout: async (): Promise<{ message: string }> => {
    return api.delete<{ message: string }>(`${AUTH_API_PATH}/logout`)
  }
}